import { useMemo } from 'react'
import { useAuth } from './AuthContext'
import { hasAnyPermission, hasAnyRole } from './rbac'

export function useAccess() {
    const { user } = useAuth()

    const allow = useMemo(() => ({
        role: (roles) => hasAnyRole(user, roles),
        perm: (perms) => hasAnyPermission(user, perms),
    }), [user])

    const guard = useMemo(() => ({
        disableIfNoPerm: (perms) => ({ disabled: !hasAnyPermission(user, perms) }),
        hideIfNoPerm: (perms) => ({ style: { display: hasAnyPermission(user, perms) ? undefined : 'none' } }),
        disableIfNoRole: (roles) => ({ disabled: !hasAnyRole(user, roles) }),
        hideIfNoRole: (roles) => ({ style: { display: hasAnyRole(user, roles) ? undefined : 'none' } }),
    }), [user])

    return { user, allow, guard }
}
